<script setup lang="ts">
import Avatar from '@/assets/icons/Avatars/AvatarIcon.vue';
import type { MessageSchema } from '@/i18n';
import { useUserStore } from '@/stores/useUserStore';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import type { ModelRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const visible: ModelRef<boolean | undefined> = defineModel<boolean>('visible', { required: true });

const userStore = useUserStore();
const router = useRouter();

function handleConfirm() {
  userStore.confirmCreditWarning();
  visible.value = false;
}

function goToPurchaseCredits() {
  userStore.confirmCreditWarning();
  router.push({ path: '/subscription/credits/purchase' });
  visible.value = false;
}
</script>

<template>
  <Dialog v-model:visible="visible" modal :header="t('credits.warning.title')" :style="{ width: '25rem', maxWidth: '90vw' }">
    <Avatar class="mx-auto my-4 w-32" />
    <p>{{ t('credits.warning.message', { credits: userStore.remainingCredits }) }}</p>
    <template #footer>
      <div class="flex w-full justify-between">
        <Button :label="t('common.ok')" outlined @click="handleConfirm" />
        <Button :label="t('credits.buyMore')" @click="goToPurchaseCredits" />
      </div>
    </template>
  </Dialog>
</template>
